import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState, useCallback, useEffect } from 'react';
import { Icon as Icon$2 } from './style.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["path", "pathMobile", "size", "sizeMobile", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Icon = function Icon(_ref) {
  var path = _ref.path,
    pathMobile = _ref.pathMobile,
    size = _ref.size,
    sizeMobile = _ref.sizeMobile,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isClient = typeof window !== 'undefined';
  var _useState = useState({
      smallScreen: isClient && window && window.innerWidth < 768
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var handleResize = useCallback(function () {
    setState({
      smallScreen: isClient && window && window.innerWidth < 768
    });
  }, [isClient]);
  useEffect(function () {
    if (!isClient) {
      return false;
    }
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize, isClient]);
  var iconSize = state.smallScreen && sizeMobile ? sizeMobile : size;
  var iconPath = state.smallScreen && pathMobile ? pathMobile : path;
  if (!path) {
    return false;
  }
  return /*#__PURE__*/jsx(Icon$2, _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    xmlns: "https://www.w3.org/2000/svg",
    className: className,
    fill: "currentColor",
    size: iconSize
  }, rest), {}, {
    children: /*#__PURE__*/jsx("path", {
      className: "sg-icon__path",
      d: iconPath
    })
  }));
};
Icon.defaultProps = {
  size: 's',
  sizeMobile: 's',
  pathMobile: null,
  className: null
};
var Icon$1 = Icon;

export { Icon$1 as default };
//# sourceMappingURL=Icon.js.map
